import axios from 'axios';
import jwtDecode from 'jwt-decode';
import { getAuth } from 'firebase/auth';

export function verifyToken(serviceToken) {
    if (!serviceToken) return null;

    const decoded = jwtDecode(serviceToken);

    return decoded.exp > Date.now() / 1000;
}

// const baseURL = process.env.REACT_APP_API_URL || 'http://192.168.29.62:8000/';
// const baseURL = 'http://192.168.29.62:8000/';

// // axios new instance with custom configuartion
// const axiosServices = axios.create({
//     baseURL:
//         window.location.hostname === 'www.shmooz.in'
//             ? process.env.REACT_APP_PROD_API_URL
//             : baseURL,
//     // timeout: 10000,
// });

// axios new instance with custom configuration
const axiosServices = axios.create({
    baseURL: (function () {
        // Check if the hostname is 'www.shmooz.in'
        if (window.location.hostname === 'www.shmooz.in') {
            return 'https://api-staging.shmooz.in/';
        }

        // Check if the hostname is 'localhost' or '192.168.29.247'
        else if (window.location.hostname === 'localhost' ||
            window.location.hostname === '192.168.29.247') {
            // return 'http://192.168.29.61:8000/';
            // return 'https://frozen-yields-exciting-crucial.trycloudflare.com/';
            // return process.env.REACT_APP_API_URL;
            return 'https://api-staging.shmooz.in/'
        }

        // Default to REACT_APP_API_URL if none of the above conditions match
        else {
            return process.env.REACT_APP_API_URL;
        }
    })(),
    // timeout: 10000,
});


// Interceptor for request in axios instance before sending it to the server
// Checking that user has serviceToken or not before request sent to server and if user has serviceToken then add it to the header
// Authorization header is used to send the serviceToken to the server with subsequent requests
axiosServices.interceptors.request.use(
    async (config) => {
        const auth = getAuth();
        const user = auth.currentUser;

        if (user) {
            try {
                // 🔁 Force refresh to get a guaranteed fresh token
                const token = await user.getIdToken();

                // (Optional) Store or update the token in localStorage
                localStorage.setItem('serviceToken', token);

                // Set token in Authorization header
                config.headers.Authorization = `Bearer ${token}`;
            } catch (err) {
                console.error('Failed to get fresh ID token:', err);
                config.headers.Authorization = null;
            }
        } else {
            config.headers.Authorization = null;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Interceptor for response in axios instance before sending it to the client side
// Checking that if user is not authorized then redirect user to login page
axiosServices.interceptors.response.use(
    (response) => response,
    (error) => {
        if (!error?.config?.url?.includes('user_search') && error.response?.status === 401) {
            // window.location.href = '/login';
            // console.log('Unauthorized access - redirecting to login', error.response, error);
            // place your reentry code
        }
        return Promise.reject((error.response && error.response) || error || 'Wrong Services'); // TODO important
    }
);

export default axiosServices;

// Interceptors in Axios are functions that allow you to intercept and modify requests or responses before they are handled by then or catch.
// They are useful for tasks such as adding authentication tokens, logging, error handling, and modifying request/response data.
